export class RmReceivingReportReq {
    grnDate: any;
    unitId?:number
    constructor(grnDate: any,unitId?:number){
        this.grnDate = grnDate;
        this.unitId = unitId
    }
}

export class RmReceivingReportModel {
    grnDate: string;
    farmers:RmReceivingDataModel[];
    agents:RmReceivingDataModel[];
    dealersAp:RmReceivingDataModel[];
    dealersOthers:RmReceivingDataModel[];
    ownPonds:RmReceivingDataModel[];
    constructor(
        grnDate: string,
        farmers:RmReceivingDataModel[],
        agents:RmReceivingDataModel[],
        dealersAp:RmReceivingDataModel[],
        dealersOthers:RmReceivingDataModel[],
        ownPonds:RmReceivingDataModel[],
    ){
 this.agents = agents
 this.dealersAp = dealersAp
 this.dealersOthers = dealersOthers
 this.farmers = farmers
 this.grnDate = grnDate 
 this.ownPonds = ownPonds
    }
}

export class RmReceivingDataModel {
    grnItemId:number
    batchNo:string
    name:string
    city:string
    count:number
    quantity:number
    rate: number
    transport:number
    remarks: string
    harvest: string
    supervisor:string
    defect?:string
    defectQty?:number
    amount?:number
    commission?:number
    financier?:string
billType?:string
indentDate?:string
product?:number
    constructor(
        grnItemId:number,
    batchNo:string,
    name:string,
    city:string,
    count:number,
    quantity:number,
    rate: number,
    transport:number,
    remarks: string,
    harvest: string,
    supervisor:string,
    defect?:string,
    defectQty?:number,
    amount?:number,
    commission?:number,
    financier?:string,
    billType?:string,
indentDate?:string,
product?:number

    ){
this.batchNo = batchNo
this.city  = city
this.count = count
this.grnItemId = grnItemId
this.harvest = harvest
this.name = name
this.quantity = quantity
this.rate = rate
this.remarks = remarks
this.supervisor = supervisor
this.transport = transport
this.defect = defect
this.defectQty = defectQty
this.amount = amount
this.commission = commission
this.financier = financier
this.billType = billType
this.indentDate = indentDate
this.product = product
    }
}

export class RmReceivingDashReq {
    grnDate?: any;
    type?: string;
    constructor(grnDate?: any, type?: string){
        this.grnDate = grnDate;
        this.type = type;
    }
}
